import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";

import { InputLabel, Select, MenuItem } from "@material-ui/core";

import { useAvailableCountries } from "lib/config";

export default function CountrySelector({
  country,
  onCountryChange,
  label,
  disabled,
  allowedCountries = "all",
}) {
  const { t } = useTranslation();

  const handleCountryChange = (event) => {
    onCountryChange(event.target.value);
  };

  const availableCountries = useAvailableCountries();

  const countryList = useMemo(() => {
    if (allowedCountries === "all") {
      return availableCountries;
    } else {
      return availableCountries.filter(({ id }) =>
        allowedCountries.includes(id)
      );
    }
  }, [allowedCountries, availableCountries]);

  const selectedCountry = country || "";
  return (
    <div>
      {label ? (
        <InputLabel shrink id="country-select-label">
          {label}
        </InputLabel>
      ) : undefined}
      <Select
        displayEmpty
        labelId="country-select-label"
        id="country-select"
        value={selectedCountry}
        onChange={handleCountryChange}
        style={{ width: "100%" }}
        disabled={disabled}
      >
        <MenuItem value="" disabled>
          {t("countrySelector.placeHolder")}
        </MenuItem>
        {countryList.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}
